import dayjs from 'dayjs';
import { seekStartPosition } from './helpers';
import { tracer } from './print';

/**
 * Seek drag seekbar or select a date to a new timestamp
 */
export async function seekTimestamp(
  context,
  startTimestamp,
  endTimestamp,
  startPosition,
  pauseAfterLoad,
  signal
) {
  context.kvService.stopLoad();

  let calcStartTimestamp = startTimestamp;
  if (startPosition) {
    calcStartTimestamp = dayjs(startTimestamp)
      .subtract(startPosition, 'seconds')
      .valueOf();
  }

  let bufferCheck = null;
  try {
    bufferCheck = await context.kvService.checkBackBufferFragmentExist(
      startTimestamp,
      startPosition,
      signal
    );
    tracer('seekTimestamp/bufferCheck', {
      startTimestamp: dayjs(startTimestamp).format('HH:mm:ss'),
      bufferCheck,
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      // the 'AbortError' is thrown when the user try dragging freqeuntly
      // in this case we don't show anything or reset the 'currentTimeIsChanging' because next request will reset the 'currentTimeIsChanging'.
      return;
    } else {
      // reset to rever avoid freezing the timeline.
      context.currentTimeIsChanging = false;
      context.clearWaitingForNewTimestamp();
      return;
    }
  }

  const { useBackBuffer, startFragExist } = bufferCheck;
  await context.changeFragmentTime({
    startTimestamp: useBackBuffer ? calcStartTimestamp : startTimestamp,
    endTimestamp: endTimestamp || dayjs().valueOf(),
    live: false,
    pauseAfterLoad:
      pauseAfterLoad === undefined ? !context.isPlaying : pauseAfterLoad,
    noLoading: true,
    startPosition: useBackBuffer ? seekStartPosition : undefined,
    // TODO: at this moment there is no implementation to check if the first expected fragment is same as the first fragment that will be fetched from the KVS
    // response. Therefore, we need to load the fragment from KVS to check if the fragment is the same as the first fragment in the KVS response of kvs.service.
    // if start fragment or backbuffer fragment exist then skip the fragment check
    skipFragCheck: useBackBuffer || startFragExist,
  });
  context.currentTimeIsChanging = false;
}
